// extracted by mini-css-extract-plugin
module.exports = {"container":"CoolHeader_container__MASgl"};